<template>
    <!--web view-->
    <v-layout class="d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
        <v-app-bar scroll-behavior="hide" :elevation="0" height="110" absolute flat color="background">
            <v-container>
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <div class="justify-center mt-2">
                            <img alt="Sigma logo" src="../assets/logo.png" height="100" contain @click="home" />
                        </div>
                    </v-col>

                    <v-col cols="12" sm="7" md="7">
                        <div class="mt-9 justify-center rounded-pill">
                            <form @submit.prevent="searchProduct">
                                <v-text-field prepend-inner-icon="mdi-magnify" variant="outlined" label="Search Product"
                                    rounded="5" rounded-pill class="rounded-pill search-field primary"
                                    base-color="primary" density="compact" @click:prepend-inner="searchProduct"
                                    v-model="search"></v-text-field>
                            </form>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <div class="mt-9 justify-center">
                            <!--<v-btn color="primary" icon class="mr-3" @click="locationDialog = true" variant="flat"
                                size="small" v-if="userLogin == false">
                                <v-icon color="white">mdi-map-marker-radius-outline</v-icon>
                            </v-btn>-->

                            <v-btn color="primary" icon class="mr-3" href="/cart" variant="flat" size="small">
                                <v-badge floating  color="orange" :content=getCartCount> <v-icon color="white">mdi-cart-outline</v-icon></v-badge>
                            </v-btn>
                            <v-menu transition="slide-x-reverse-transition">
                                <template v-slot:activator="{ props }">
                                    <v-btn variant="flat" color="black" v-bind="props" rounded="pill">
                                        <v-icon color="white">mdi-account-circle-outline</v-icon> &nbsp;My Account
                                    </v-btn>
                                </template>
                                <v-sheet elevation="12" max-width="350" rounded="lg" class="text-left mx-auto"
                                    color="white">
                                    <div class="pa-5">
                                        <h2 class="text-h5 text-black font-weight-bold mb-1">Welcome {{ username }}</h2>
                                        <p class="mb-4 text-black text-body-2" v-if="username == 'Guest'">
                                            Register to enjoy the best features, offers and more
                                        </p>
                                        <p class="mb-4 text-black text-body-2" v-else>
                                            Explore our wide range of fresh and organic produce
                                        </p>
                                        <div class="text-start" v-if="userLogin == false">
                                            <!--<v-btn class="text-none text-subtitle-2 font-weight-bold mr-5 account-btn"
                                                color="primary" width="120" rounded variant="flat" href="/register">
                                                <p class="text-white"> REGISTER</p>
                                            </v-btn>-->
                                            <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn"
                                                color="black" rounded variant="flat" width="100" href="/login">
                                                LOGIN
                                            </v-btn>
                                        </div>

                                        <div class="text-start" v-if="userLogin == true">
                                            <v-btn class="text-none text-subtitle-2 font-weight-bold mr-5 account-btn"
                                                color="primary" width="120" rounded variant="flat"
                                                @click="logoutDialog = true">
                                                <p class="text-white"> LOGOUT</p>
                                            </v-btn>
                                        </div>
                                    </div>

                                    <v-divider></v-divider>
                                    <div class="text-start bg-white" v-if="userLogin == true">
                                        <v-list lines="two" class="bg-white">
                                            <v-list-item title="My Orders" subtitle="See your current/past orders"
                                                prepend-icon="mdi-receipt-text-outline" @click="ordersRedirect">
                                            </v-list-item>
                                            <v-list-item title="My Profile" subtitle="Change/view your address"
                                                prepend-icon="mdi-map-marker-outline" @click="addressDialog = true">
                                            </v-list-item>
                                        </v-list>
                                    </div>
                                </v-sheet>
                            </v-menu>


                        </div>

                    </v-col>
                </v-row>
            </v-container>
        </v-app-bar>

        <v-main>
            <!--main Category List-->
            <AppMainCategory />
            <!--main Category List-->
        </v-main>

    </v-layout>
    <!--web view end-->

    <!--Mobile View-->
    <div class="d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none">
        <v-toolbar color="primary" height="145">
            <v-container>
                <v-row dense>
                    <v-col cols="3">
                        <div class="justify-center mt-n6">
                            <img alt="Sigma logo" src="../assets/mobile-logo.png" height="70" contain @click="home" />
                        </div>
                    </v-col>
                    <v-col cols="9">
                        <div class="justify-right text-right mt-n1">
                            <v-btn color="white" class="text-capitalize" @click="locationDialog = true"
                                v-if="userLogin == false">
                                <p class="location-text"> {{ locationDetails.name }} <v-icon
                                        icon="mdi-near-me"></v-icon>
                                </p>
                            </v-btn>

                            <v-btn color="white" class="text-capitalize" v-if="userLogin == true">
                                <p class="location-text"> {{ locationDetails.name }} <v-icon
                                        icon="mdi-near-me"></v-icon>
                                </p>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-toolbar>
        <v-row dense class="search-bar ma-3 mt-n12">
            <v-col cols="7">
                <div class="justify-center rounded-pill">
                    <form @submit.prevent="searchProduct">
                        <v-text-field append-inner-icon="mdi-magnify" variant="outlined" label="Search Product"
                            rounded="5" rounded-pill class="rounded-pill search-field primary" base-color="primary"
                            bg-color="white" density="compact" @click:prepend-inner="searchProduct"
                            v-model="search"></v-text-field>
                    </form>
                </div>
            </v-col>
            <v-col cols="5">
                <div class="justify-center">
                    <v-btn color="background" icon class="mr-3" href="/cart" variant="flat" size="large"
                        density="comfortable">
                        <v-badge floating  color="orange" :content=getCartCount> <v-icon color="black">mdi-cart-outline</v-icon></v-badge>
                    </v-btn>
                    <v-menu transition="slide-x-reverse-transition">
                        <template v-slot:activator="{ props }">
                            <v-btn variant="flat" color="background" v-bind="props" rounded="pill" icon size="large"
                                density="comfortable">
                                <v-icon color="black">mdi-account-circle-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-sheet elevation="12" max-width="350" rounded="lg" class="text-left mx-auto" color="white">
                            <div class="pa-5">
                                <h2 class="text-h5 text-black font-weight-bold mb-1">Welcome {{ username }}</h2>
                                <p class="mb-4 text-black text-body-2" v-if="username == 'Guest'">
                                    Register to enjoy the best features, offers and more
                                </p>
                                <p class="mb-4 text-black text-body-2" v-else>
                                    Explore our wide range of fresh and organic produce
                                </p>
                                <div class="text-start" v-if="userLogin == false">
                                    <v-btn class="text-none text-subtitle-2 font-weight-bold mr-5 account-btn"
                                        color="primary" width="120" rounded variant="flat" href="/register">
                                        <p class="text-white"> REGISTER</p>
                                    </v-btn>
                                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black"
                                        rounded variant="flat" width="100" href="/login">
                                        LOGIN
                                    </v-btn>
                                </div>
                                <div class="text-start" v-if="userLogin == true">
                                    <v-btn class="text-none text-subtitle-2 font-weight-bold mr-5 account-btn"
                                        color="primary" width="120" rounded variant="flat" @click="logoutDialog = true">
                                        <p class="text-white"> LOGOUT</p>
                                    </v-btn>
                                </div>
                            </div>
                            <v-divider></v-divider>
                            <div class="text-start bg-white">
                                <v-list lines="two" class="bg-white">
                                    <v-list-item title="My Orders" subtitle="See your current/past orders"
                                        prepend-icon="mdi-receipt-text-outline" @click="ordersRedirect">
                                    </v-list-item>
                                    <v-list-item title="My Profile" subtitle="Change/view your address" prepend-icon="mdi-map-marker-outline" @click="addressDialog = true"></v-list-item>
                                </v-list>
                            </div>
                        </v-sheet>
                    </v-menu>
                </div>
            </v-col>
        </v-row>

    </div>
    <!--Mobile View End-->

    <v-dialog width="500" v-model="locationDialog" class="" persistent>
        <v-card class="text-center justify-center align-center rounded-xl" min-height="350" color="white">
            <div class="pa-4 justify-center align-center">
                <h2 class="text-h5 text-black font-weight-bold mb-3">Welcome to Sigma Farmers Market</h2>
                <p class="mb-4 text-black text-body-1">
                    Select your delivery location
                </p>
                <p class="mb-4 text-body-2 text-red" v-if="locationChange == true">Note : Changing your location will
                    empty
                    your
                    cart.</p>
                <div v-for="location in locationList" :key="location.id">
                    <v-btn block color="#E7E8E8" rounded
                        class="text-none bg-lime-lighten-2 text-black mb-4 mx-auto  font-weight-bold location-btn"
                        variant="flat" @click="setLocation(location.id, location.name)"
                        v-if="currentLocationId == location.id">
                        {{ location.name }}
                    </v-btn>
                    <v-btn block color="#E7E8E8" rounded
                        class="text-none text-grey-darken-2 mb-4 mx-auto  font-weight-bold location-btn" variant="flat"
                        @click="setLocation(location.id, location.name)" v-if="currentLocationId != location.id">
                        {{ location.name }}
                    </v-btn>
                </div>

            </div>
        </v-card>
    </v-dialog>


    <v-dialog width="500" v-model="loginDialog" class="" persistent>
        <v-card class="text-center justify-center align-center rounded-xl" min-height="350" color="white">
            <div class="pa-4 justify-center align-center">
                <h2 class="text-h5 text-black font-weight-bold mb-3">Welcome to Sigma Farmers Market</h2>
                <p class="mb-4 text-black text-h6">
                    Login
                </p>
                <!--alert box-->
                <v-alert type="error" class="text-left ma-5" border v-if="loginStatusmsg">
                    <div v-for="(resp, i) in loginStatusResponse" :key="i">
                        {{ resp }}
                    </div>
                </v-alert>
                <!--alert box end-->

                <form class="mt-5">

                    <v-text-field v-model="mobileno" :error-messages="v$.mobileno.$errors.map(e => e.$message)"
                        :counter="10" label="Mobile no" required @input="v$.mobileno.$touch" @blur="v$.mobileno.$touch"
                        variant="outlined" color="black" type="number" class="mb-2"></v-text-field>

                    <v-text-field v-model="password" :error-messages="v$.password.$errors.map(e => e.$message)"
                        label="Password" required @input="v$.password.$touch" @blur="v$.password.$touch"
                        variant="outlined" color="black" type="password" class="mb-2"></v-text-field>

                    <v-btn class="text-none text-subtitle-2 font-weight-bold mb-5 cart-btn float-left" color="primary"
                        rounded variant="flat" block width="220" @click="submit">
                        <p class="text-white"> LOGIN</p>
                    </v-btn>

                    <v-btn class="text-subtitle-2 font-weight-bold" variant="text" href="https://www.sigmafarmersmarket.com/partner-with-us/"> 
                        New User? Click here to &nbsp;<span class="text-decoration-underline" color="black"> Register</span>
                    </v-btn>
                   

                    <!-- <v-btn class="text-subtitle-2 font-weight-bold mb-3 cart-btn float-md-left" rounded variant="text" >
                        Buy Our Products in Bulk Visit Our Website
                    </v-btn> -->

                </form>


            </div>
        </v-card>
    </v-dialog>

    <v-dialog width="500" v-model="logoutDialog" class="" persistent>
        <v-card color="white" class="ma-5 pa-5 text-center">
            <v-card-title class="text-h5">
                Are you sure want to Logout?
            </v-card-title>

            <v-card-actions class="mt-3 justify-center">
                <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="warning" variant="flat"
                    rounded @click="logout" width="120">
                    LOGOUT
                </v-btn>
                <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black" variant="flat"
                    rounded @click="logoutDialog = false" width="100">
                    CLOSE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    

    <v-dialog width="500" v-model="addressDialog" class="rounded-xl" persistent height="auto">
        <v-card color="white" class="ma-5 pa-5 text-center">
            <v-card-title class="text-h5 mb-3">
                My Profile
            </v-card-title>



            <v-text-field v-model="profile_name" :error-messages="v$.profile_name.$errors.map(e => e.$message)" label="Name*"
                required @input="v$.profile_name.$touch" @blur="v$.profile_name.$touch" variant="outlined" color="black"
                class="mb-2" type="text"></v-text-field>


            <v-text-field v-model="profile_email" :error-messages="v$.profile_email.$errors.map(e => e.$message)" label="Email"
                @input="v$.profile_email.$touch" @blur="v$.profile_email.$touch" variant="outlined" color="black" class="mb-2"
                type="text"></v-text-field>

            <v-text-field v-model="profile_flat_door_no" :error-messages="v$.profile_flat_door_no.$errors.map(e => e.$message)"
                label="Flat / Door No*" required @input="v$.profile_flat_door_no.$touch" @blur="v$.profile_flat_door_no.$touch"
                variant="outlined" color="black" class="mb-2"></v-text-field>


            <v-text-field v-model="profile_address" :error-messages="v$.profile_address.$errors.map(e => e.$message)"
                label="Address*" required @input="v$.profile_address.$touch" @blur="v$.profile_address.$touch" variant="outlined"
                color="black" class="mb-2"></v-text-field>

            <v-text-field v-model="profile_address2" label="Address 2" variant="outlined" color="black"
                class="mb-2"></v-text-field>

            <v-select v-model="profile_locality_id" :items="getLocality" item-title="name" item-value="id" label="Locality"
                variant="outlined" color="black"></v-select>

            <v-text-field v-model="profile_pincode" :error-messages="v$.profile_pincode.$errors.map(e => e.$message)"
                label="Pincode*" required @input="v$.profile_pincode.$touch" @blur="v$.profile_pincode.$touch" variant="outlined"
                color="black" class="mb-2"></v-text-field>

            <v-text-field v-model="profile_geo_location"  label="Geo Location" variant="outlined"
                color="black" class="mb-2"></v-text-field>

            <v-divider></v-divider>

            <v-card-actions class="mt-3 text-center justify-left">
                <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="primary" variant="flat"
                    rounded @click="addressFormUpdate" width="120">
                    <p class="text-white">UPDATE</p>
                </v-btn>
                <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black" variant="flat"
                    rounded @click="addressDialog = false" width="100">
                    CLOSE
                </v-btn>
            </v-card-actions>

            <!--alert box-->
            <v-alert type="success" v-if="addressStatusmsg" class="mt-3 text-left" border color="primary"
                min-height="55">
                <div class="text-white d-none  d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                    {{ addressStatusResponse }}
                </div>

                <div class="text-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mb-2 alert-text">
                    {{ addressStatusResponse }}
                </div>
            </v-alert>
            <div v-if="addressErrorStatusmsg" class="mt-3">
                <v-alert type="error" v-for="(resp, i) in addressStatusResponse" :key="i" class="mb-1 text-left"
                    border min-height="55">
                    <div class="text-white d-none  d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                        {{ resp }}
                    </div>

                    <div
                        class="text-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mb-2 alert-text">
                        {{ resp }}
                    </div>
                </v-alert>
            </div>

            <!--alert box end-->
        </v-card>
    </v-dialog>
    
</template>

<style>
.search-field .v-field {
    border-radius: 50px;
}

.location-text {
    font-size: 22px;
}

.search-bar {
    position: absolute;
    z-index: 2;
    width: 95%;
}
</style>

<script>
import AppMainCategory from '@/components/MainCategoryList.vue'
import router from "../router";
import { mapActions, mapGetters } from "vuex";
import store from "../store";

import { useVuelidate } from '@vuelidate/core'
import { required, numeric, email, minLength, maxLength, helpers } from '@vuelidate/validators'

export default {
    name: 'TopBar',
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            locationDialog: false,
            logoutDialog: false,
            loginDialog: false,
            currentLocationId: '',
            locationChange: false,
            addressDialog: false,
            search: '',
            mobileno: '',
            password: '',
            username: (localStorage.getItem('user-token') !== null) ? localStorage.getItem('user-name') : 'Guest',
        }
    },
    validations() {
        return {

            mobileno: {
                required: helpers.withMessage('This field cannot be empty', required),
                numeric,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
            password: { required: helpers.withMessage('This field cannot be empty', required) },
            
            profile_name: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            profile_email: { email },
            profile_flat_door_no: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            profile_address: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            //profile_locality_id: {
            // required: helpers.withMessage('This field cannot be empty', required)
            // },
            profile_pincode: {
                required: helpers.withMessage('This field cannot be empty', required),
                numeric,
                minLength: minLength(6),
                maxLength: maxLength(6),
            },
        }
    },
    components: {
        AppMainCategory,
    },
    props: {
        msg: String
    },
    created() {
        //this.locationDialog = true;
        //console.log(sessionStorage.getItem("locationChange"));
        /*this.getLocations();
        if (sessionStorage.getItem("locationChange") === null && this.userLogin == false) {
            this.locationDialog = true;
        }

        if (sessionStorage.getItem("locationChange")) {
            this.locationChange = true;
        }*/
        if (this.userLogin == false) {
            this.loginDialog = true;
        }

        this.currentLocationId = store.getters.UserLocation;
        this.currentLocationName = localStorage.getItem('currentLocationName');

        //console.log(this.$route.params.name);
        this.search = this.$route.params.name;

        this.getlocationDetails();
        this.addressDetails();
        this.cartcount();
    },
    computed: {
        ...mapGetters([
            "locationList",
            "UserLocation",
            "getUserToken",
            "getLoginStatus",
            "getLoginResponse",
            "locationDetails",
            "getCartCount",
            "getAddress",
            "getLocality",
            "getAddressStatus",
            "getAddressResponse",
        ]),
        loginStatusmsg: function () {
            return this.getLoginStatus === "error";
        },
        loginStatusResponse: function () {
            return this.getLoginResponse;
        },
        userLogin: function () {
            return this.getUserToken != "";
        },
        addressStatusmsg: function () {
            return this.getAddressStatus === "success";
        },
        addressErrorStatusmsg: function () {
            return this.getAddressStatus === "error";
        },
        addressStatusResponse: function () {
            return this.getAddressResponse;
        },
        profile_name: {
            get() {
                return this.getAddress.name;
            },
            set(value) {
                this.$store.commit("updateCustomerName", value);
            }
        },
        profile_email: {
            get() {
                return this.getAddress.email;
            },
            set(value) {
                this.$store.commit("updateCustomerEmail", value);
            }
        },
        profile_flat_door_no: {
            get() {
                return this.getAddress.flat_door_no;
            },
            set(value) {
                this.$store.commit("updateCustomerFlat", value);
            }
        },
        profile_address: {
            get() {
                return this.getAddress.address;
            },
            set(value) {
                this.$store.commit("updateCustomerAddress", value);
            }
        },
        profile_address2: {
            get() {
                return this.getAddress.address2;
            },
            set(value) {
                this.$store.commit("updateCustomerAddress2", value);
            }
        },
        profile_locality_id: {
            get() {
                return this.getAddress.locality_id;
            },
            set(value) {
                this.$store.commit("updateCustomerLocalityId", value);
            }
        },
        profile_pincode: {
            get() {
                return this.getAddress.pincode;
            },
            set(value) {
                this.$store.commit("updateCustomerPincode", value);
            }
        },
        profile_geo_location: {
            get() {
                return this.getAddress.geo_location;
            },
            set(value) {
                this.$store.commit("updateCustomerGeoLocation", value);
            }
        },
    },
    methods: {
        ...mapActions([
            "getLocations",
            "loginAction",
            "logoutAction",
            "getlocationDetails",
            "cartcount",
            "addressDetails",
            "addressUpdate",
        ]),
        async submit() {
            await this.v$.$validate()
            // if (!result) {
            if (this.v$.mobileno.$invalid ||
                this.v$.password.$invalid) {
                // notify user form is invalid
                console.log('enter');
                return
            }
            // perform async actions

            const loginData = {
                mobileno: this.mobileno,
                password: this.password
            };

            //console.log(customerData);
            this.loginAction(loginData);
        },
        async addressFormUpdate() {
            await this.v$.$validate()
            //const result = await this.v$.$validate()
            //console.log(this.v$.name);
            //console.log(this.v$.name.$invalid);
            if (this.v$.profile_name.$invalid ||
                this.v$.profile_flat_door_no.$invalid ||
                this.v$.profile_address.$invalid ||
                //this.v$.profile_locality_id.$invalid ||
                this.v$.profile_pincode.$invalid) {
                // notify user form is invalid
                console.log('enter');
                return
            }
            // perform async actions

            const addressData = {
                name: this.profile_name,
                email: this.profile_email,
                flat_door_no: this.profile_flat_door_no,
                address: this.profile_address,
                address2: this.profile_address2,
                locality_id: this.profile_locality_id,
                pincode: this.profile_pincode,
                geo_location: this.profile_geo_location
            };

            //console.log(addressData);
            this.addressUpdate(addressData);
        },
        home() {
            router.push("/");
        },
        setLocation(id, name) {
            sessionStorage.setItem("locationChange", true);
            this.locationDialog = false;
            if (localStorage.getItem('currentLocation') != id) {
                localStorage.removeItem("cart-token");
            }
            localStorage.setItem('currentLocation', id);
            localStorage.setItem('currentLocationName', name);
            location.reload();
        },
        logout() {
            this.logoutAction();
        },
        searchProduct() {
            if (this.search) {
                router.push("/search/" + this.search);
            }
        },
        ordersRedirect() {
            router.push("/orders");
        }
    },
}
</script>